import request from '@/utils/request'

import {
  TicketItemData,
  TicketDetailParams,
  TicketItemDetail,
  SetTicketEvaluationParams,
  confirmOrderParams,
  GetTicketListParams,
  GetDeliveryServiceDetail,
  GetPreDeliveryServiceDetail,
  GetTicketVideo,
  GetAuthInfo,
  GetXDeliveryServiceDetail,
} from '@/types/complete-machine-delivery'

export function getTicketList(params: GetTicketListParams): Promise<TicketItemData> {
  return request.get(`/api/agri/wo/list`, { params })
}

// 详情
export function getTicketDetail(params: TicketDetailParams): Promise<TicketItemDetail> {
  return request.get(`/api/agri/wo/info`, { params })
}

//评价工单
export function setTicketEvaluation(params: SetTicketEvaluationParams): Promise<void> {
  return request.post(`/api/agri/wo/assess`, params)
}

//确认完成工单
export function confirmOrder(params: confirmOrderParams): Promise<void> {
  return request.post(`/api/agri/wo/confirm_completion`, params)
}

// 现场交付详情
export function getDeliveryServiceDetail(params: {
  wo_guid: string
}): Promise<GetDeliveryServiceDetail> {
  return request.get(`/api/agri/wo/on_site_info`, { params })
}
// 现场交付步骤信息

// 预交付详情
export function getPreDeliveryServiceDetail(params: {
  wo_guid: string
}): Promise<GetPreDeliveryServiceDetail> {
  return request.get(`/api/agri/wo/wo_info_detection_info`, { params })
}

// 获取领取设备权益
export function getAuthInfo(params: { wo_guid: string }): Promise<GetAuthInfo> {
  return request.get(`/api/agri/wo/auth_info`, { params })
}

// 未完成交付
export function getUnfinishedDeliveryDetail(params: { order_no: string }): Promise<void> {
  return request.post(`/api/agri/wo/not_confirm_completion`, params)
}

// 获取工单视频
export function getTicketVideo(params: { wo_guid: string }): Promise<GetTicketVideo> {
  return request.get(`/api/agri/wo/gzh_url`, { params })
}

// 小程序获取X系列现场交付详情信息
export function getXDeliveryServiceDetail(params: {
  wo_guid: string
}): Promise<GetXDeliveryServiceDetail> {
  return request.get(`/api/agri/wo/x_on_site_info`, { params })
}
